import * as DateHelper from '../../util/DateHelper';

    
    
// If dates have been introduced by hand they will be in RO locale and need to be converted to ISO
export const formatAuthzIscirDates = (authz) => {
    if(DateHelper.isRoLocaleStringDate(authz.autorizatie.dataAutorizatie)) 
        authz.autorizatie.dataAutorizatie =  DateHelper.getDateFromString(authz.autorizatie.dataAutorizatie).toISOString();
    if(DateHelper.isRoLocaleStringDate(authz.autorizatie.dataEliberare)) 
        authz.autorizatie.dataEliberare =  DateHelper.getDateFromString(authz.autorizatie.dataEliberare).toISOString();

    if(DateHelper.isRoLocaleStringDate(authz.talon?.dataEliberareTalon)) 
        authz.talon.dataEliberareTalon =  DateHelper.getDateFromString(authz.talon.dataEliberareTalon).toISOString();

    if(DateHelper.isRoLocaleStringDate(authz.talon?.dataVizaTalonAn1)) 
        authz.talon.dataVizaTalonAn1 =  DateHelper.getDateFromString(authz.talon.dataVizaTalonAn1).toISOString();
    if(DateHelper.isRoLocaleStringDate(authz.talon?.dataVizaTalonAn2)) 
        authz.talon.dataVizaTalonAn2 =  DateHelper.getDateFromString(authz.talon.dataVizaTalonAn2).toISOString();
    if(DateHelper.isRoLocaleStringDate(authz.talon?.dataVizaTalonAn3)) 
        authz.talon.dataVizaTalonAn3 =  DateHelper.getDateFromString(authz.talon.dataVizaTalonAn3).toISOString();
    if(DateHelper.isRoLocaleStringDate(authz.talon?.dataVizaTalonAn4)) 
        authz.talon.dataVizaTalonAn4 =  DateHelper.getDateFromString(authz.talon.dataVizaTalonAn4).toISOString();
    
    return authz;
}


export const formatAuthzInternalDates = (authz) => {
    if(DateHelper.isRoLocaleStringDate(authz.autorizatie.dateCertificate)) 
        authz.autorizatie.dateCertificate =  DateHelper.getDateFromString(authz.autorizatie.dateCertificate).toISOString();
    if(DateHelper.isRoLocaleStringDate(authz.autorizatie.dateMaturity)) 
        authz.autorizatie.dateMaturity =  DateHelper.getDateFromString(authz.autorizatie.dateMaturity).toISOString();

    return authz;
}